__turbopack_context__.v({
  "appShell": "page-module__xLttZq__appShell",
});
